"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readTimeToDate = void 0;
const readTime_1 = require("./readTime");
function readTimeToDate(date, timeStr, zone) {
    const [hours, minutes] = (0, readTime_1.readTime)(timeStr);
    return date.setZone(zone).set({
        hour: hours,
        minute: minutes,
        second: 0,
        millisecond: 0,
    });
}
exports.readTimeToDate = readTimeToDate;
//# sourceMappingURL=readTimeToDate.js.map